// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import { xBaseTheme } from "@stoneage/XDL/types";
import { css } from "styled-components";
import IconArrowRightLightSmall from "@stoneage/XDL/Icons/IconArrowRightLightSmall";
import { fontConfig } from "@stoneage/XDL/constants";
import { color } from "@stoneage/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";

const panelMenuText: TypographyPresentationProps = {
    ...fontConfig.regularSingleLine,
    weight: fontConfig.weight.bold,
};

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        mergeCss: true,
        bodyColor: "common.white",
        cssOverrides: {
            wrapper: css`
                justify-content: space-between;
                gap: 30px;
            `,
            children: css`
                .back-clickable {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: ${panelMenuText.size}px;
                    line-height: ${panelMenuText.lineHeight};
                    font-weight: ${panelMenuText.weight};
                }
            `,
        },
        panelRowProps: {
            css: css`
                flex: 1;
                background-color: ${color("common.white")};
                color: ${color(fontConfig.headingColor)};
                font-size: ${panelMenuText.size}px;
                line-height: ${panelMenuText.lineHeight};
                font-weight: ${panelMenuText.weight};
                text-transform: capitalize;
                width: 100%;
                &.divider {
                    position: relative;
                    &::after {
                        content: " ";
                        width: calc(100% - 32px);
                        height: 1px;
                        background: ${color("common.border")};
                        top: 100%;
                        position: absolute;
                        left: 0;
                        right: 0;
                        margin: 0 auto;
                    }
                }
            `,
            moreIconProps: {
                src: IconArrowRightLightSmall,
                size: 16,
                color: "common.ui6",
                css: css`
                    padding: 12px 16px;
                    &.p-0 {
                        padding: 0;
                    }
                    width: auto;
                    height: auto;
                    justify-content: flex-end;
                `,
            },
        },
        childTypographyProps: {
            ...panelMenuText,
            css: css`
                text-align: left;
            `,
        },
        backIconProps: {
            size: 12,
            color: "common.ui6",
        },
    },
} as xBaseTheme["panelMenu"];
